import React from 'react';
const stats = [{
  value: "1210",
  label: 'padres y madres confían'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '3',
  label: 'Bonos incluidos'
}, {
  value: '4,8/5',
  label: 'calificación ⭐'
}];
export function SocialProofBar() {
  return <section aria-label="Prueba social" className="w-full bg-bark-800 py-7" data-id="element-189" data-mp="29sctw80qu2mp">
      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-y-6 px-5 sm:px-8 md:grid-cols-4" data-id="element-190" data-mp="25uf3x2z5fci9">
        {stats.map(stat => <div key={stat.label} className="px-2 text-center" data-id="element-191" data-mp="32iblaa2eubuj">
            <p className="font-display text-2xl font-semibold text-cream-100 sm:text-3xl" data-id="element-192" data-mp="2xl33ial6c9tt">
              {stat.value}
            </p>
            <p className="mt-1 text-xs font-medium leading-snug text-cream-200/70 sm:text-sm" data-id="element-193" data-mp="2tglmgj678amq">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}